import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";
import CustomerReviews from "../../../components/desktop/customer-reviews";

const CustomerReviewsContainer = () => {
    return <CustomerReviews showDate/>;
};

export default withReducer(injectable)(() => ({}), dispatch => ({dispatch}))(
    withLayout(
        CustomerReviewsContainer,
        true,
        true,
        false,
        false
    )
);
